import { Component, Input } from '@angular/core';
import { ContentLoaderService } from './content-loader.service';

@Component({
  selector: 'content-loader',
  templateUrl: './content-loader.component.html',
  styleUrls: ['./content-loader.component.scss'],
})
export class ContentLoaderComponent {
  @Input() diameter: number;
  @Input() height: string;

  constructor(public loaderService: ContentLoaderService) {
    this.diameter = 50;
    this.height = '100dvh';
  }
}
